import { useQuery } from "@tanstack/react-query";
import createPrivateAdminPanelInstance from "../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../api/ApiRoutes";
import { bonusAdminBody } from "./bonusAdminBody";
import type { SeriesOut } from "../../components/Promotions/DynamicBonuses/types";

type StoredToken = { AccessToken?: string };

async function fetchSeriesById(seriesId: string): Promise<SeriesOut> {
  const tokenString = localStorage.getItem("token");
  const token: StoredToken | null = tokenString ? JSON.parse(tokenString) : null;
  const instance = createPrivateAdminPanelInstance(token?.AccessToken);
  const url = API_ROUTES.GET_DYNAMIC_BONUS_SERIES.replace("{series_id}", seriesId);
  const response = await instance.get(url);
  const series = bonusAdminBody<SeriesOut>(response);
  if (!series) {
    throw new Error("Series not found");
  }
  return series;
}

export const getSeriesQueryKey = (seriesId: string) =>
  ["GET_DYNAMIC_BONUS_SERIES", seriesId] as const;

export const useGetSeries = (seriesId: string) => {
  return useQuery<SeriesOut>({
    queryKey: getSeriesQueryKey(seriesId),
    queryFn: () => fetchSeriesById(seriesId),
    enabled: Boolean(seriesId),
    staleTime: 1000 * 60,
    refetchOnWindowFocus: false,
  });
};
